import { shape, string, oneOf, func } from 'prop-types';

import { bootstrapVariants } from 'utils/constants';

export const buttonCTA = shape({
  text: string,
  onClick: func.isRequired,
  size: oneOf(['sm', 'lg']),
  variant: oneOf(Object.values(bootstrapVariants)),
});
